import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3353f556")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_top_header = _resolveComponent("top-header")
  const _component_search = _resolveComponent("search")
  const _component_list = _resolveComponent("list")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_top_header),
    _createVNode(_component_search, {
      id: "searchCmp",
      page: "result"
    }),
    _createVNode(_component_list)
  ], 64))
})